import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { CheckOutlined, FileDoneOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row, Space, Input, Image } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { ApproveListData, RequestProductReq, UpdateRequestStatusReq } from 'Store/product/types'
import { selectActionEvent, selectRequestProductsList, selectListEvent } from 'Store/product/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { requestProductsAPI, updateRequestStatusAPI } from 'Store/product/api'
import { formatDateTime } from 'helpers/format'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import Detail from './detail'
import { appConfig } from 'config'
import { Pagination } from 'Components/Pagination'
import { setTimeout } from 'timers'
import { EventModal } from 'Components/modal'
import { clearEventAction } from 'Store/product/actions'

type Props = {} & ReduxProps

const ProductRequest: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, dataList, event } = props
  const queryString = location.search
  const params = new URLSearchParams(queryString)
  const isAuto = params.get('auto') === 'true'
  const time = parseInt(params.get('time') || '10')
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)

  const [filter, setFilter] = useState({
    keyword: '',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })

  const datas = dataList.data
  const meta = dataList.meta

  const onGetDataList = (): void => {
    const req: RequestProductReq = {
      keyword: filter.keyword?.trim() || '',
      merchant_id: 0,
      product_id: 0,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      status: 'pending',
    }

    dispatch(requestProductsAPI(req, currentUser.accessToken))
  }

  const onApprove = (log_id: number): void => {
    const req: UpdateRequestStatusReq = {
      log_id,
      status: 'approved',
    }
    dispatch(updateRequestStatusAPI(req, currentUser.accessToken))
  }

  useEffect(() => {
    const timers = setTimeout(() => {
      if (isAuto) {
        window.location.reload()
      }
    }, time * 1000)
    return () => {
      clearTimeout(timers)
    }
  }, [isAuto])

  useEffect(() => {
    if (isAuto && datas?.length > 0) {
      datas &&
        datas.forEach(item => {
          onApprove(item.log_id || 0)
        })
    }
  }, [isAuto, datas])

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetDataList()
    }
  }, [pagination])

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: any) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onClickEdit = (data: ApproveListData) => {
    setSelectedID(data.log_id)
    onOpenDrawer()
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetDataList()
  }

  const renderRequestReason = (is_created: boolean, record: ApproveListData) => {
    const text = record.update_remark
    return text || 'เพิ่มสินค้าใหม่'
  }

  const renderCategory = (group: any, record: ApproveListData) =>
    `${record.group_name} / ${record?.category_name || ''} / ${record?.sub_category_name || ''}`

  const renderImage = (img: string[]) => <ThumbImage src={appConfig.assetCdnEndpoint + img[0]} />

  const renderActionButton = (id: number, record: ApproveListData) => {
    return (
      <Space size="middle">
        <ActionButton
          text=""
          icon={<CheckOutlined />}
          label="อนุมัติทันที"
          action="success"
          onClick={() => onApprove(record.log_id)}
          btnid="auto-approve"
        />
        <ActionButton
          text=""
          icon={<FileDoneOutlined />}
          label="รายละเอียด"
          action="view"
          onClick={() => onClickEdit(record)}
        />
      </Space>
    )
  }

  const columnsBaady = [
    {
      title: 'รูปภาพสินค้า',
      dataIndex: 'photos',
      key: 'photos',
      render: renderImage,
      width: '120px',
    },
    {
      title: 'รหัสสินค้า',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'หมวดหมู่สินค้า',
      dataIndex: 'group',
      key: 'group',
      render: renderCategory,
    },
    {
      title: 'ชื่อร้านค้า',
      dataIndex: 'merchant_name',
      key: 'merchant_name',
    },
    {
      title: 'เหตุผลขอแก้ไข',
      dataIndex: 'update_remark',
      key: 'update_remark',
      render: renderRequestReason,
    },
    {
      title: 'สร้างเมื่อ',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (created_at: string) => formatDateTime(created_at),
    },
    {
      title: 'รายละเอียด',
      dataIndex: 'action',
      key: 'action',
      render: renderActionButton,
    },
  ]

  const columns = columnsBaady

  const DetailDrawer = (
    <Detail visible={drawer} onCloseDrawer={onCloseDrawer} onSuccess={onSuccess} logId={selectedID} />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={21}>
          <Row justify="start" gutter={[16, 16]}>
            <Col md={8} xs={24}>
              <SearchInput
                placeholder="ค้นหาชื่อสินค้า"
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onGetDataList} />
            </Col>
          </Row>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onSuccess()
  }

  return (
    <>
      <HomePageLayout
        selected="products-request"
        title="รายการอนุมัติสินค้า"
        //label="รายการผลิตภัณฑ์ สินค้า ที่ร้านของเราจัดจำหน่าย"
      >
        <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
        {FilterContent}
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={PaginationContent}
        />
        {DetailDrawer}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    dataList: selectRequestProductsList(state),
    listEvent: selectListEvent(state),
    event: selectActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`
const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 80px;
  height: 80px;
  object-fit: cover;
`

export default connect(mapStateToProps)(ProductRequest)
